import { useQuery } from '@tanstack/react-query';
import {
  fetchDashboard,
  fetchPeriodosCerrados,
  type DashboardParams,
} from '@/shared/api/efApi';

export const efKeys = {
  all: ['estados-financieros'] as const,
  dashboard: (params: DashboardParams) =>
    [
      ...efKeys.all,
      'dashboard',
      params.compania,
      params.periodo,
      params.cantidad_meses ?? 24,
      params.incluir_abierto ?? false,
    ] as const,
  periodosCerrados: (compania: string, incluirAbierto: boolean) =>
    [...efKeys.all, 'periodos-cerrados', compania, incluirAbierto] as const,
};

export function useDashboard(params: DashboardParams) {
  return useQuery({
    queryKey: efKeys.dashboard(params),
    queryFn: () => fetchDashboard(params),
    enabled: !!params.compania && !!params.periodo,
    staleTime: 1000 * 60 * 2,
  });
}

export function usePeriodosCerrados(compania: string, incluirAbierto = false) {
  return useQuery({
    queryKey: efKeys.periodosCerrados(compania, incluirAbierto),
    queryFn: () => fetchPeriodosCerrados(compania, incluirAbierto),
    enabled: !!compania,
  });
}
